import { observable } from 'mobx'

class Store {
  constructor(updateStore) {
    this.updateStore = updateStore
  }

  @observable tab = 'all'

  changeTab = tab => {
    this.tab = tab
    const type = tab == 'video' ? 3 : undefined
    this.updateStore.getMerchantUpdates(type, false)
  }
}

export default Store
